import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import { IExportList } from '../../../interfaces';
import store from '../../app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;
enum Status {
  loading = 'loading',
  done = 'done',
  fail = 'fail',
}

interface IState {
  status: Status | '';
  data: IExportList[];
  error: any;
}
const initialState: IState = {
  status: '',
  data: [],
  error: null,
};
interface IParams {
  exportType: string;
}
export const exportList = createAsyncThunk('export/list', async (params: IParams) => {
  const vendorId = store.getState().auth?.user?.vendor?.id;
  const res = await axios.get<IExportList[]>(`${VENDOR_MC_URL}/vendor/${vendorId}/export-list`, { params });
  return res.data;
});
const exportListSlice = createSlice({
  name: 'export-list',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    //
    builder.addCase(exportList.pending, (state, action) => {
      state.status = Status.loading;
    });
    builder.addCase(exportList.fulfilled, (state, action) => {
      state.status = Status.done;
      state.data = action.payload;
    });
    builder.addCase(exportList.rejected, (state, action) => {
      state.error = 'Export List Error!';
      state.status = Status.fail;
    });
  },
});

export default exportListSlice.reducer;
